"use client"

import * as TooltipPrimitive from "@radix-ui/react-tooltip"
import * as React from "react"

import { cn } from "@/lib/utils"

const TooltipProvider = TooltipPrimitive.Provider

const Tooltip = TooltipPrimitive.Root

const TooltipTrigger = React.forwardRef<
  React.ComponentRef<typeof TooltipPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Trigger>
>(({ ...props }, ref) => (
  <TooltipPrimitive.Trigger
    onClick={ (e) => !props.asChild && e.preventDefault() }
    ref={ ref }
    type="button"
    { ...props } />
));
TooltipTrigger.displayName = TooltipPrimitive.Trigger.displayName



const TooltipContent = React.forwardRef<
  React.ComponentRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ className, sideOffset = 4, color, ...props }, ref) => (
  <TooltipPrimitive.Content
    ref={ ref }
    sideOffset={ sideOffset }
    className={ cn(
      "z-50 rounded-md border px-3 py-1.5 text-sm shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 border-nfPurple-500 bg-black/40 backdrop-blur-md text-slate-50",
      className
    ) }
    { ...props }
  >
    <TooltipPrimitive.TooltipArrow className={ cn("fill-nfPurple-500", color) } />
    { props.children }
  </TooltipPrimitive.Content>
))
TooltipContent.displayName = TooltipPrimitive.Content.displayName

export { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger }

